import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ComponentProps } from 'react';

import styles from './contactsEmptyState.module.scss';

export type ContactsEmptyStateProps = ComponentProps<typeof EmptyState>;

/** Component that is used to show empty states in the context of contacts */
export function ContactsEmptyState({
  className,
  ...rest
}: ContactsEmptyStateProps): JSX.Element {
  return (
    <FlexBox width="100%" height="100%" alignItems="center">
      <EmptyState
        {...rest}
        className={classnames(className, styles.emptyState)}
      />
    </FlexBox>
  );
}
